module.exports = __webpack_public_path__ + "img/E-Wallet-amico.62b184e3.svg";